import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { isUserLoggedInSelector } from '../store/App/selectors';

/**
 * A React hook for continuously polling an endpoint to check if user is in session.
 * @param {number} interval - Polling interval in milliseconds.
 * @returns null
 */

const useSessionChecker = (interval = 20000) => {
  const intervalRef = useRef(null);
  const isUserLoggedIn = useSelector(isUserLoggedInSelector);
  useEffect(() => {
    const checkSession = async () => {
      const response = await fetch('/studio/api/v1/check-session');
      if (response.status === 401 && isUserLoggedIn) {
        window.location.reload();
      }
    };

    if (isUserLoggedIn) {
      intervalRef.current = setInterval(checkSession, interval);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current); // Stop polling if user logs out
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current); // Cleanup on unmount
      }
    };
  }, [isUserLoggedIn]);

  return null;
};

export default useSessionChecker;
